<template>
    <div class="whiteHeader">
        <div class="position-relative">
            <div class="whiteHeader__inner whiteHeader__inner--horizontal">
                <span class="whiteHeader__progressLink is-active is-done">
                    1. {{$t('components.BasketMenu.goods')}}
                </span>
                <a href="#" class="whiteHeader__progressLink" @click.prevent="editTransportationAndPayment()" v-bind:class="{'is-done': isDeliveryAndPaymentSelected}">
                    2. {{$t('components.BasketMenu.deliveryAndPayment')}}
                </a>
                <a href="#" class="whiteHeader__progressLink" @click.prevent="orderSumarize()">
                    3. {{$t('components.BasketMenu.deliveryInfo')}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BasketMenu',
        computed: {
            isDeliveryAndPaymentSelected: function () {
                return this.$store.getters.isDeliveryAndPaymentSelected;
            },
        },
        methods: {
            editTransportationAndPayment: function () {
                this.$store.dispatch("editTransportationAndPayment", {});
            },
            orderSumarize: function () {
                this.$store.dispatch("orderSumarize", {});
            }
        }
    };
</script>
